import React from 'react';
import PropTypes from 'prop-types';
import { styleUtils } from '../../utils';
import { brStyles as styles } from './styles';

const { style } = styleUtils;
const SIZES = ['small', 'normal', 'large', 'xlarge', 'title'];

const Br = ({size, lines, ...otherProps}) => {
  const sizeStyle = styles[size] || styles.normal;
  const Component = style('br', sizeStyle);

  return lines > 0 ? <Component size={size} lines={lines} {...otherProps} /> : null
};

Br.propTypes = {
  lines: PropTypes.number,
  size: PropTypes.oneOf(SIZES)
};

Br.defaultProps = {
  lines: 1,
  size: 'normal'
};

export default Br;
